export default __webpack_public_path__ + "static/media/kiara.7328e16e.gif";